<template>
  <div class="menu-hide-page article-create">
    <h3 class="page-title page-title-bb">
      <h4 class="breadcrumb-c">
        <router-link
          :to="{
            name: 'material',
            query: {
              type: 1
            }
          }"
          class="back-btn"
        >
          <i class="fa fa-angle-left"></i> 素材库
        </router-link>
        / 新建图文链接
      </h4>
    </h3>

    <form class="form-horizontal form" role="form">
      <div class="hbox tab-pane">
        <section>
          <div class="form-body article-main-info m-article">
            <!--<div class="form-group">
                          <label class="col-sm-3 control-label">分组</label>
                          <div class="col-sm-8">
                              <select class="form-control" v-model="gid">
                                  <option value="0">未分组</option>
                                  <template v-for="g in groups">
                                      <option :value="g.objectId">{{g.title}}</option>
                                  </template>
                              </select>
                          </div>
                      </div>-->

            <div class="form-group main-item" style="margin-bottom:10px;">
              <div class="col-sm-12">
                <input
                  class="form-control article-title"
                  v-model="title"
                  placeholder="请输入标题"
                />
              </div>
            </div>

            <div class="form-group main-item">
              <div class="col-sm-12">
                <input
                  class="form-control article-author"
                  v-model="author"
                  placeholder="请输入作者"
                />
              </div>
            </div>

            <div class="form-group main-item">
              <div class="col-sm-12 editor-metro" style="position: relative;">
                <c-editor
                  :config.sync="editor"
                  @editor-content-chg="editorContentChg"
                ></c-editor>
              </div>
            </div>
          </div>

          <div class="form-group main-item" id="codeview" style="display:none">
            <div class="col-sm-12">
              <pre>{{ editor.content }}</pre>
            </div>
          </div>

          <div class="form-body article-ext-info">
            <div class="form-group">
              <label class="control-label col-sm-2"
                >封面
                <span class="required"> * </span>
              </label>
              <div class="col-sm-8">
                <div>
                  <p class="form-control-static form-limit-tip">
                    大图建议尺寸：900*560
                  </p>
                </div>
                <c-file-upload :config.sync="cover"></c-file-upload>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">摘要</label>
              <div class="col-sm-7">
                <p class="form-control-static form-limit-tip">
                  选填，如果不填写会默认抓取正文前54个字
                </p>
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="digest"
                  style="height:120px;"
                ></textarea>
              </div>
            </div>
          </div>
        </section>
        <aside class="article-aside">
          <h3>多媒体</h3>
          <!--<ul class="list-group">
                      <li class="list-group-item" @click="insertImg()"> <i class="fa fa-image"></i>图片</li>
                      <li class="list-group-item" @click="insertVideo()"> <i class="fa fa-video-camera"></i>视频</li>
                      <li class="list-group-item" @click="insertAudio()"> <i class="fa fa-microphone"></i>音频</li>
                      <li class="list-group-item" @click="insertArticle()"> <i class="fa fa-newspaper-o"></i>图文链接</li>
                  </ul>-->
        </aside>
      </div>
      <div class="form-actions" style="z-index: 1000;">
        <div class="container">
          <div class="hbox tab-pane">
            <section style="border-right:0;">
              <div class="form-body" style="padding-top:0;padding-bottom:0;">
                <div class="form-group" style="margin-bottom:0;">
                  <div class="col-sm-offset-2 col-sm-8">
                    <button
                      type="button"
                      class="btn m-white"
                      @click="preview()"
                    >
                      预览
                    </button>
                    <button type="button" class="btn m-green" @click="submit()">
                      保存
                    </button>
                  </div>
                </div>
              </div>
            </section>
            <aside class="article-aside"></aside>
          </div>
        </div>
      </div>
    </form>

    <c-modal2 :config="previewConf">
      <div class="article m-article preview">
        <div class="article-inner">
          <h2 class="article-title">{{ title }}</h2>
          <div class="article-meta">
            <!--<em class="article-meta">2017-03-23</em>-->
            <a class="article-meta">{{ author }}</a>
          </div>
          <div class="article-content" v-html="editor.content"></div>
        </div>
      </div>

      <div class="video-player-wrap">
        <div class="mask"></div>
        <div class="v-player">
          <video
            id="video-player"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            preload="auto"
          >
            <!--data-setup='{}'-->
            <!--<source src="http://video-js.zencoder.com/oceans-clip.mp4" type="video/mp4" />
                    <source src="http://video-js.zencoder.com/oceans-clip.webm" type="video/webm" />
                    <source src="http://video-js.zencoder.com/oceans-clip.ogv" type="video/ogg" />-->
            <p class="vjs-no-js">
              To view this video please enable JavaScript, and consider
              upgrading to a web browser that
              <a href="#" target="_blank">supports HTML5 video</a>
            </p>
          </video>
        </div>
      </div>
    </c-modal2>
  </div>
</template>

<script type="text/javascript">
import $ from 'jquery';

import { mapState, mapActions } from 'vuex';

import cFileUpload from '../../components/fileupload';
import cEditor from '../../components/editor';
import cModal2 from '../../components/modal2';
import videojs from 'video.js';

export default {
  data() {
    return {
      articleId: null,
      // content: '',
      title: '',
      author: '',
      digest: '',
      gid: localStorage.getItem('group') || 'ungroup',
      showPreview: false,
      cover: {
        nolocal: true,
        space: 'image',
        type: 'image',
        name: 'file',
        fileName: null,
        file: null,
        imgId: null
      },
      editor: {
        name: 'html-editor',
        placeholder: '请输入正文',
        height: 500,
        content: ''
      },
      previewConf: {
        show: false,
        title: '文章预览',
        hideOnClickOut: true,
        theme: '',
        width: 700
      }
    };
  },
  components: {
    cFileUpload,
    cEditor,
    cModal2
  },
  computed: mapState(['groups']),
  mounted() {
    // compute height
    // this.editor.height = ;
    var self = this;
    this.articleId = this.$route.query.id;
    if (this.articleId) {
      this.$api
        .get_material_article_info({
          id: this.articleId
        })
        .then(function(data) {
          console.log(data);

          if (data && data.data && data.code === 200) {
            self.author = data.data.author;
            self.title = data.data.title;
            self.digest = data.data.digest;
            self.gid = data.data.gid;
            self.cover.imgId = data.data.coverId;
            self.cover.url = data.data.coverUrl;
            self.editor.content = data.data.content;
          }
        });
    }

    initPreview();
  },
  methods: {
    ...mapActions([
      'toast',
      'showAlert',
      'showConfirm',
      'showLoading',
      'hideLoading',
      'showSelectImgWin',
      'showSelectVideoWin',
      'showSelectAudioWin',
      'showSelectArticleWin',
      'showPlayer',
      'hidePlayer'
    ]),
    _submit(type) {
      let self = this;

      return this.$api.update_material_article_add({
        articleId: self.articleId,
        title: self.title,
        content: self.editor.content,
        author: self.author,
        coverId: self.cover.imgId,
        digest: self.digest,
        gid: self.gid,
        type: type
      });
    },
    submit() {
      let self = this;

      if (!this.title) {
        this.showAlert('文章标题不能为空！');
        return;
      }

      if (!this.editor.content) {
        this.showAlert('文章内容不能为空！');
        return;
      }

      if (!this.cover.imgId) {
        this.showAlert('文章封面不能为空！');
        return;
      }
      this.showLoading('发布中，请稍后。。。');

      this._submit()
        .then(function(data) {
          if (data && data.code === 200) {
            self.showAlert('恭喜您，添加成功！');
          } else {
            self.showAlert('操作失败，请稍后再试！');
          }

          self.back();
        })
        .catch(function() {
          self.showAlert('操作失败，请稍后再试！');
          self.back();
        })
        .finally(function() {
          self.hideLoading();
        });
    },
    preview() {
      this.previewConf.show = true;
      /*let self = this;
      this.showLoading('预览生产中，请稍后。。。');

      this._submit('preview')
        .done(function(data){

          if(data && data.code === 200) {
            // 跳转到预览页面
          } else {
            self.showAlert('预览失败，请稍后再试！');
          }

        })
        .fail(function(){
          self.showAlert('操作失败，请稍后再试！');
        })
        .always(function(){
          self.hideLoading();
        });*/
    },
    back() {
      //this.$emit('article-create-complete');
      this.$router.push({
        name: 'material',
        query: {
          type: 1
        },
        replace: true
      });
    },
    editorContentChg(content) {
      this.content = content;
    },
    insertImg: function() {
      let self = this;

      if (!this.editor || !this.editor.$el) return;

      this.showSelectImgWin({
        ok: function(img) {
          if (!img) {
            return;
          }

          self.editor.$el.summernote('focus');

          self.editor.$el
            .data('summernote')
            .invoke('editor.insertImage', img.imgUrl, function($image) {
              $image.css('width', '100%');
              $image.attr('data-filename', 'retriever');
            });

          /*self.editor.$el.summernote('insertImage', img.imgUrl, function ($image) {
              $image.css('width', '100%');
              $image.attr('data-filename', 'retriever');
          });*/

          // img.imgUrl;
          // img.objectId;
        }
      });
    },
    insertVideo: function() {
      let self = this;

      if (!this.editor || !this.editor.$el) return;

      this.showSelectVideoWin({
        ok: function(video) {
          if (!video) {
            return;
          }

          let $video = $(
            '<div class="article-video-wrap">' +
              '<img src="' +
              video.coverUrl +
              '" />' +
              '</div>'
          );

          console.log(self.editor.$el.summernote());
          self.editor.$el.summernote('insertNode', $video[0], function($v) {});
          /*self.editor.$el.summernote('insertImage', img.imgUrl, function ($image) {
              $image.css('width', '100%');
              $image.attr('data-filename', 'retriever');
          });*/

          // img.imgUrl;
          // img.objectId;
        }
      });
    },
    insertAudio: function() {
      let self = this;

      if (!this.editor || !this.editor.$el) return;

      this.showSelectAudioWin({
        ok: function(audio) {
          if (!audio) {
            return;
          }

          let $audio = $(
            `<div class="article-audio-wrap">` +
              `<img src="${audio.coverUrl}" />` +
              `</div>`
          );

          self.editor.$el.summernote('insertNode', $audio[0], function($v) {});
        }
      });
    },
    insertArticle: function() {}
  }
};

function initPreview() {
  // videojs.options.flash.swf = "/assets/js/videojs/video-js.swf";

  var width = $(window).width();
  width = width > 700 ? 700 : width;

  var currentEl;

  var _player = videojs(
    $('#video-player')[0],
    {
      width: width,
      language: 'zh-CN'
    },
    function() {
      // Player (this) is initialized and ready.
    }
  );

  // video

  $('body').on('click', '.article-video-wrap .play-btn', function() {
    var url = $(this).data('videourl');

    if (!url) {
      return;
    }

    currentEl = $(this)[0];
    _player.src(url);

    $('.video-player-wrap').show();
    $('.video-player-wrap .v-player').width(width);
  });

  $('body').on('click', '.video-player-wrap .mask', function() {
    $('.video-player-wrap').hide();
    _player.pause();
  });

  // audio
  $('body').on('click', '.article-audio-wrap', function() {
    var url = $(this).data('audiourl');

    if (!url) {
      return;
    }

    if (currentEl === $(this)[0]) {
      if (_player.paused()) {
        _player.play();
      } else {
        _player.pause();
      }
    } else {
      currentEl = $(this)[0];
      _player.src(url);
      _player.play();
    }
  });
  $('body').on('click', '.article-audio-wrap .mask', function() {
    $('.video-player-wrap').hide();
    _player.pause();
  });
}
</script>

<style>
@import '../../assets/css/editor-theme.css';
@import '../../assets/css/web.css';

.article-create .form-actions {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
}

.article-create .hbox {
  border: none;
}

.article-aside {
  width: 220px;
  padding: 10px;
}

.article-aside h3 {
  font-size: 14px;
  margin-bottom: 40px;
}

.article-aside .list-group-item {
  padding: 15px;
  padding-left: 50px;
  font-size: 14px;
  color: #222;
  cursor: pointer;
  border-color: #eef1f5;
}

.article-aside .list-group-item i {
  font-size: 20px;
  margin-right: 12px;
  position: absolute;
  left: 15px;
  top: 50%;
  margin-top: -10px;
  line-height: 20px;
  color: #b4b4b4;
}

.article-aside .list-group > li:first-child {
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
}

.article-aside .list-group > li:last-child {
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}

.article-create div.article-main-info {
  padding-top: 80px;
  position: relative;
  border-bottom: 1px solid #eef1f5;
}

.article-create div.article-ext-info {
  padding-bottom: 80px;
}

.main-item {
  padding-left: 50px;
}

.main-item .form-control {
  border: none;
  padding-left: 0px;
}

.main-item .article-title {
  font-size: 24px;
  height: auto;
}

.article-author {
}

.article-create .note-editor.note-frame {
  border: none;
  border-top: 1px solid #eef1f5;
}

.article-create .note-editor.note-frame .note-editing-area .note-editable {
  padding: 5px 0px;
  margin-top: 8px;
}

.article-create .note-editor.note-frame .note-statusbar {
  display: none;
}

.article-create .note-editor.note-frame .note-placeholder {
  padding-left: 0px;
  color: #888;
}

.preview {
  height: 400px;
  overflow-y: auto;
}
</style>
<style></style>
